import React, { useEffect } from 'react';
import styled from '@emotion/styled';
import * as constants from '../constants';
import { TakeActionLink, TakeActionButton } from './buttons';
import { useIcons } from '../hooks/icons';
import SVG from 'react-inlinesvg';
import { Link, useStaticQuery, graphql } from 'gatsby';

const Sharing = (
  props: {
    copy: {
      download?: string;
    };
    urls: {
      download?: string;
      facebook?: string;
      twitter?: string;
      instagram?: string;
    };
    share: boolean;
  } = {
    copy: {},
    urls: {},
    share: true,
  }
) => {
  const icons = useIcons();

  useEffect(() => {
    require('sharer.js/sharer.js');
    Sharer.init();
  }, []);

  const getPageUrl = () => {
    const pageUrl = typeof window !== 'undefined' ? window.location.href : '';
    return pageUrl;
  };

  const pageUrl = getPageUrl();

  return (
    <SharingContainer>
      {props.urls.download && (
        <TakeActionLink
          className="download-law-btn"
          href={props.urls.download}
          target="_blank"
        >
          <span>{props.copy.download || 'Download the Law'}</span>
          <SVG src={icons.download.publicURL} className="icon" />
        </TakeActionLink>
      )}

      {props.share && (
        <div>
          <h3 className="share-btn-title">Share this on</h3>
          <div className="sharing">
            <TakeActionButton
              className="share-btn"
              type="button"
              data-sharer="twitter"
              data-url={pageUrl}
              data-hashtags="Nixthe6"
            >
              Twitter
            </TakeActionButton>
            <TakeActionButton
              className="share-btn"
              type="button"
              data-sharer="facebook"
              data-url={pageUrl}
            >
              Facebook
            </TakeActionButton>

            <TakeActionLink
              href={`${pageUrl}${pageUrl.endsWith('/') ? '' : '/'}instagram`}
            >
              Instagram
            </TakeActionLink>
          </div>
        </div>
      )}
      {!props.share && (
        <p className="text-sm">
          In our initial review of this contract we did not identify provisions
          blocking accountability, but we encourage communities to reevaluate
          their contracts and send us any relevant information they think should
          be included in our analysis.
        </p>
      )}
    </SharingContainer>
  );
};

export const SharingContainer = styled.div`
  .download-law-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${constants.highlightForegroundColor};
    color: ${constants.highlightColor};
    margin: 2rem 0;
    padding: 1.5rem 1rem;
    font-size: 22px;
    letter-spacing: 0;
    transition: ${constants.colorTransition};

    @media (max-width: 767.98px) {
      font-size: 15px;
      letter-spacing: 0;
      text-align: center;
      line-height: 16px;
    }

    .icon {
      margin-left: 1rem;
      width: 35px;
      height: 34px;

      @media (max-width: 767.98px) {
        display: none;
      }

      > g {
        transition: fill linear 150ms;
      }
    }

    &:hover {
      color: #fff;

      .icon > g {
        fill: #fff;
      }
    }
  }

  h3.share-btn-title {
    font-weight: bold;
    font-size: 15px !important;
    text-transform: uppercase;
    text-align: center !important;
    margin: 0 auto 0.5rem !important;
  }

  .sharing {
    display: flex;

    @media (max-width: 767.98px) {
      flex-direction: column;
    }

    .share-btn {
      font-size: 16px;
      width: 50%;
      color: #231f20;
      letter-spacing: 0;
      text-align: center;
      transition: ${constants.colorTransition};
      margin-right: 1rem;

      @media (max-width: 767.98px) {
        width: 100%;
        font-size: 15px;
        line-height: 16px;
        margin-bottom: 1rem;
      }

      &:last-child {
        margin-right: 0;
        margin-bottom: 0;
      }

      &:hover {
        color: #fff;
      }
    }
  }
`;

export default Sharing;
